export const SITUACAO_MANDATO_ENUM = Object.freeze({
  EM_MANDATO: {
    value: 'EM_MANDATO',
    text: 'Em Mandato',
    color: 'green',
  },
  SEM_MANDATO: {
    value: 'SEM_MANDATO',
    text: 'Sem Mandato',
    color: 'red',
  },
  DISPONIVEL_PARA_ANALISE: {
    value: 'DISPONIVEL_PARA_ANALISE',
    text: 'Disponível para Análise',
    color: 'orange',
  },
  EM_ANALISE: {
    value: 'EM_ANALISE',
    text: 'Em Análise',
    color: 'blue',
  },
  NEGADO: {
    value: 'NEGADO',
    text: 'Negado',
    color: 'grey darken-2',
  },
});

export function getSituacaoMandatoConfig(value) {
  return SITUACAO_MANDATO_ENUM[value] || {
    value,
    text: value || '-',
    color: 'grey',
  };
}

export function getSituacaoMandatoLabel(value) {
  return getSituacaoMandatoConfig(value).text;
}

export function getSituacaoMandatoColor(value) {
  return getSituacaoMandatoConfig(value).color;
}

export function getSituacoesMandatoOptions() {
  return Object.values(SITUACAO_MANDATO_ENUM).map(item => ({
    text: item.text,
    value: item.value,
  }));
}